import React, { useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  wrapper: {
    position: 'relative',
    display: 'inline-flex',
    alignItems: 'center',
  },

  tooltip: {
    position: 'absolute',
    zIndex: 1500,

    bottom: 'calc(100% + 6px)',
    left: '50%',

    backgroundColor: '#fff',
    color: '#000',

    fontSize: 10,
    lineHeight: 1.4,

    padding: '6px 9px',
    borderRadius: 8,

    maxWidth: 280,
    width: 'max-content',

    pointerEvents: 'none',

    whiteSpace: 'normal',

    transform: 'translate(-50%, -4px)',

    transition: 'opacity 120ms ease',

    boxShadow: '0px -1px 20px 1px rgba(16, 24, 40, 0.18), 0 2px 4px -2px rgba(16, 24, 40, 0.08)',
  },

  hidden: {
    opacity: 0,
    visibility: 'hidden',
  },

  visible: {
    opacity: 1,
    visibility: 'visible',
  },
}));

export default function AppTooltip({
  title,
  children,
  placement = 'top',
}) {
  const classes = useStyles();
  const [visible, setVisible] = useState(false);

  return (
    <span
      className={classes.wrapper}
      onMouseEnter={() => setVisible(true)}
      onMouseLeave={() => setVisible(false)}
    >
      {children}

      <span
        className={`${classes.tooltip} ${
          visible ? classes.visible : classes.hidden
        }`}
      >
        {title}
      </span>
    </span>
  );
}